module.exports = __webpack_public_path__ + "img/blur.e41ab312.jpg";